(function ($) {
    $(document).ready(function () {
        var fieldSelector = "[data-sc-field-name = '" + globalModel.name + "']";

        $(fieldSelector).autocomplete({
            source: function (request, response) {
                var control = $(fieldSelector);
                var apiUrl = control.attr('data-uri');
                var numOfRecord = control.attr('num-of-record-show');
                var lobValue = control.attr('lob-value');
                var language = control.attr('lang-type');

                $.ajax({
                    url: apiUrl,
                    data: JSON.stringify({
                        searchText: control.val(),
                        numberOfRows: numOfRecord,
                        lob: lobValue,
                        language: language
                    }),
                    dataType: "json",
                    type: "POST",
                    contentType: "application/json; charset=utf-8",
                    success: function (data) {
                        response($.map(data.SearchResult, function (item) {
                            return { label: item.Value, value: item.Value };
                        }));
                    },
                    error: function (response) {
                        alert(response.responseText);
                    },
                    failure: function (response) {
                        alert(response.responseText);
                    }
                });
            },
            minLength: $(fieldSelector).attr('search-char-length')
        });
    });
}(jQuery));
